module.exports = __webpack_public_path__ + "img/icon_account1.28bc5249.90d81833.svg";